<div class="container py-5 min-vh-100">
  <div class="row justify-content-center mb-5">
    <div class="col-lg-10 text-center animate-fade-in">
      <img src="assets/logo.png" alt="ServiTrack" class="img-fluid mb-4 logo-premium shadow-sm">
      
      <h5 class="display-5 fw-bold text-dark mb-2">
        Bienvenido a Servitrack - Enduro Bikes Dominicana
      </h5>      
      <button class="btn btn-primary btn-lg rounded-pill px-5 shadow-sm btn-hover-lift" (click)="navigateToDashboard()">
        <i class="bi bi-speedometer2 me-2"></i> Ir al Panel de Servicios
      </button>
    </div>
  </div>

  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-grow text-primary" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
    <p class="mt-3 text-muted fw-bold">Calculando telemetría del taller...</p>
  </div>

  <div *ngIf="stats$ | async as stats" class="animate-slide-up">
    
    <!-- Selector de Período (Pills) -->
    <div class="d-flex justify-content-center mb-5">
      <div class="bg-white p-2 rounded-pill shadow-sm d-inline-flex">
        <button class="btn rounded-pill px-4" 
                [class.btn-primary]="selectedPeriod === 'week'" 
                [class.btn-light]="selectedPeriod !== 'week'"
                (click)="setPeriod('week')">
          <i class="bi bi-calendar-week me-2"></i>Esta Semana
        </button>
        <button class="btn rounded-pill px-4 mx-2" 
                [class.btn-primary]="selectedPeriod === 'month'" 
                [class.btn-light]="selectedPeriod !== 'month'"
                (click)="setPeriod('month')">
          <i class="bi bi-calendar-month me-2"></i>Este Mes
        </button>
        <button class="btn rounded-pill px-4" 
                [class.btn-primary]="selectedPeriod === 'year'" 
                [class.btn-light]="selectedPeriod !== 'year'"
                (click)="setPeriod('year')">
          <i class="bi bi-calendar3 me-2"></i>Este Año
        </button>
      </div>
    </div>

    <!-- Título Dinámico -->
    <div class="text-center mb-4">
      <h3 class="fw-bold text-secondary text-uppercase tracking-wider small">
        Resumen Operativo: 
        <span *ngIf="selectedPeriod === 'week'" class="text-primary">Últimos 7 días</span>
        <span *ngIf="selectedPeriod === 'month'" class="text-primary">Mes Actual</span>
        <span *ngIf="selectedPeriod === 'year'" class="text-primary">Año en Curso</span>
      </h3>
    </div>

    <!-- Grid de Métricas -->
    <div class="row g-4 justify-content-center mb-5">
      <div *ngFor="let status of statusOrder" class="col-6 col-md-4 col-lg-2">
        <div class="card h-100 border-0 shadow-sm rounded-24 metric-card text-center overflow-hidden">
          <div class="card-body p-4 d-flex flex-column align-items-center justify-content-center">
            
            <!-- Ícono del Estado -->
            <div class="icon-wrapper mb-3" [ngClass]="getStatusColor(status).replace('text-', 'bg-') + '-subtle'">
              <i class="bi fs-3" [ngClass]="[getStatusIcon(status), getStatusColor(status)]"></i>
            </div>
            
            <!-- Contador Numérico -->
            <h2 class="display-5 fw-bold text-dark mb-1">
              {{ stats[selectedPeriod][status] || 0 }}
            </h2>
            
            <!-- Etiqueta del Estado -->
            <span class="small fw-bold text-muted text-uppercase text-truncate w-100 px-2" [title]="getSpanishStatus(status)">
              {{ getSpanishStatus(status) }}
            </span>
            
          </div>
          <!-- Barra inferior decorativa -->
          <div class="card-footer p-1 border-0" [ngClass]="getStatusColor(status).replace('text-', 'bg-')"></div>
        </div>
      </div>
    </div>

    <hr class="my-5 border-light">

    <!-- Resumen Histórico Global (Total) -->
    <div class="row justify-content-center">
      <div class="col-12 text-center mb-4">
        <h4 class="fw-bold text-muted"><i class="bi bi-globe me-2"></i>Total Histórico (Todos los tiempos)</h4>
      </div>
      <div class="col-lg-10">
        <div class="card border-0 bg-white shadow-sm rounded-24 p-4">
          <div class="d-flex flex-wrap justify-content-around gap-3">
            <div *ngFor="let status of statusOrder" class="text-center px-3 py-2">
              <h4 class="fw-bold text-dark mb-0">{{ stats.total[status] || 0 }}</h4>
              <small class="text-muted text-uppercase" style="font-size: 0.7rem;">{{ getSpanishStatus(status) }}</small>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>